export const boxStyle = {
  width: '220px',
  height: '40px',
  mr: '8px',
}

export const textFieldStyle = {
  '& .MuiOutlinedInput-input': {
    padding: '8.5px 14px',
    fontSize: '16px',
    lineHeight: '24px',
  },
  fontSize: '16px',
  lineHeight: '24px',
  fontStyle: 'normal',
  width: '220px',
  height: '40px',
  ml: 0,
  background: 'white',
}
